// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-tabs-content-holder:has(.employee-daily-updates-scrollable) {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.ant-tabs-content:has(.employee-daily-updates-scrollable) {
  height: 100%;
}

.ant-tabs-tabpane:has(.employee-daily-updates-scrollable) {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Employees/EmployeeDailyUpdates.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ant-tabs-content-holder:has(.employee-daily-updates-scrollable) {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.ant-tabs-content:has(.employee-daily-updates-scrollable) {\n  height: 100%;\n}\n\n.ant-tabs-tabpane:has(.employee-daily-updates-scrollable) {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
